export default __webpack_public_path__ + "static/media/html-.11531028.svg";